var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "salemon-agent" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      {},
      [
        _c("nav-tabs", { attrs: { tab: _vm.tab } }),
        _vm._v(" "),
        _c("tab-content", { attrs: { tab: _vm.tab } })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("div", {}, [
        _c("img", {
          staticClass: "img-responsive",
          attrs: {
            src: "https://image-yoshino.sakura.ne.jp/monster/SaleMonAgentH.png",
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-primary font-bold" }, [
        _vm._v(
          "セルモンエージェントとは、セラー様にとってお得になる情報をご提案するサービスです！"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8160b04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8160b04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/salemonAgent/SalemonAgent.vue
// module id = null
// module chunks = 